app.controller('ProductsMenuCtrl', ['$rootScope', 'PageTitle', function($rootScope, PageTitle) {
  PageTitle.set('Products - Supplier Hub | RedBalloon');
}]);
